import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import operationTypes from 'constants/operationTypes';

import movementTypes from 'modules/transactions/constants/movementTypes';
import ModalAlert from 'modules/_shared/components/ModalAlert';
import HistoryMovementsView from 'modules/_shared/components/HistoryMovementsView';
import { HistoryMovementsViewProvider } from 'modules/_shared/components/HistoryMovementsView/context/HistoryMovementsViewContext';

import { useReclassificationModal } from '../context/ReclassificationModalContext';
import ReclassificationHoldingClassMode from './ReclassificationHoldingClassMode';
import ReclassificationPartnerMode from './ReclassificationPartnerMode';

const ReclassificationDataView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useReclassificationModal();

  const isDisabled =
    data.historyMovements.length > 0 &&
    data.historyMovements.some(
      (movement) =>
        movement.movementType === movementTypes.ENTIRE_CLASS_RECLASSIFICATION
    );

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="assignment-method">
          {t('HowDoYouWantToAssignTheNe')}
        </label>

        <div className="row">
          <div className="col-md-6">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                name="assignmentMethod"
                id="assignment-by-class"
                checked={data.isReclassificationByClass}
                onChange={actions.handleChangeIsReclassificationByClass}
                disabled={isDisabled}
              />
              <label
                className="custom-control-label"
                htmlFor="assignment-by-class"
              >
                {t('ManualByClasses')}
              </label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                name="assignmentMethod"
                id="assignment-by-partner"
                checked={!data.isReclassificationByClass}
                onChange={actions.handleChangeIsReclassificationByClass}
                disabled={isDisabled}
              />
              <label
                className="custom-control-label"
                htmlFor="assignment-by-partner"
              >
                {t('ManualByPartners')}
              </label>
            </div>
          </div>
        </div>
      </div>

      {data.isReclassificationByClass ? (
        <ReclassificationHoldingClassMode />
      ) : (
        <ReclassificationPartnerMode />
      )}

      <div className="mt-4">
        <HistoryMovementsViewProvider
          historyMovements={data.historyMovements}
          operationType={operationTypes.RECLASSIFICATION}
        >
          <HistoryMovementsView />
        </HistoryMovementsViewProvider>
      </div>
      {data.isEntireClassReclassification && (
        <ModalAlert
          text={t('EntireClassReclassificationAlert')}
          hasCloseButton
        />
      )}
    </>
  );
};

export default ReclassificationDataView;
